import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const userAuthApi = createApi({
  reducerPath: 'userAuthApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://vikasmandalmulund.com/vmm_admin_panel/public/api/v1/', // Replace with your actual base URL
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    // ... your existing endpoints (like login, register, etc.) ...
    logoutQuery: builder.mutation({
      query: ({token}) => {
        return {
          url: "logout",
          method: "POST",
          body: {},
          headers: {
            "Content-type": "application/json",
            'Authorization': `Bearer ${token}`,
          },
        };
      },
    }),
    getLoggedUser: builder.query({
      query: ({token}) => {
        return {
          url: 'show-list',
          method: 'POST',
          body: {},
          headers: {
            "Content-type": "application/json",
            'Authorization': `Bearer ${token}`,
          }
        }
      }
    }),
    // ADD THIS ENDPOINT HERE:
    getMasters: builder.query({
      query: () => ({
        url: 'masters', // Replace with your actual endpoints path (e.g., 'get-dropdowns' or 'masters')
        method: 'GET',
      }),
    }),
    contactUsQuery: builder.mutation({
      query: (user) => {
        return {
          url: "contact-us",
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json",
          },
        };
      },
    }),
  }),
})

// Export the auto-generated hook explicitly
export const {
  useLogoutQueryMutation,
  useGetLoggedUserQuery,
  useGetMastersQuery,
  useContactUsQueryMutation,
  // ... export your other hooks here ...
} = userAuthApi;